import { Layout } from "@/components/layout/Layout";
import { Helmet } from "react-helmet-async";

const CookiePolicy = () => {
  return (
    <Layout>
      <Helmet>
        <title>Cookie Policy | Taekwondo Mattei</title>
        <meta name="description" content="Informativa sui cookie di Taekwondo Mattei ASD. Scopri quali cookie utilizziamo e come gestirli." />
        <link rel="canonical" href="https://taekwondomattei.com/cookie-policy" />
        <meta property="og:title" content="Cookie Policy | Taekwondo Mattei" />
        <meta property="og:description" content="Informativa sui cookie di Taekwondo Mattei ASD." />
        <meta property="og:url" content="https://taekwondomattei.com/cookie-policy" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="it_IT" />
      </Helmet>

      <section className="pt-32 pb-20 bg-background">
        <div className="container-wide mx-auto px-4 md:px-8">
          <h1 className="font-display text-4xl md:text-5xl font-bold text-foreground mb-8">
            Cookie Policy
          </h1>
          
          <div className="prose prose-lg max-w-none text-foreground/80">
            <p className="text-lg mb-6">
              <strong>Titolare del Trattamento:</strong> A.S.D. Taekwondo Mattei Roma<br />
              <strong>Codice Fiscale:</strong> 97831630583<br />
              <strong>Sede legale:</strong> Via Forno Saraceno, 129 – Roma<br />
              <strong>Email:</strong> taekwondomatteiroma@gmail.com<br />
              <strong>Ultimo aggiornamento:</strong> Febbraio 2026
            </p>

            <h2 className="font-display text-2xl font-bold text-foreground mt-10 mb-4">
              1. Cosa sono i Cookie
            </h2>
            <p>
              I cookie sono piccoli file di testo che i siti web visitati inviano al dispositivo dell'utente (computer, tablet, smartphone), dove vengono memorizzati per essere poi ritrasmessi agli stessi siti alla visita successiva. I cookie permettono al sito di ricordare le azioni e preferenze dell'utente (come login, lingua, dimensioni dei caratteri e altre impostazioni di visualizzazione) in modo che non debbano essere indicate nuovamente quando l'utente ritorna o naviga da una pagina all'altra.
            </p>

            <h2 className="font-display text-2xl font-bold text-foreground mt-10 mb-4">
              2. Tipologie di Cookie Utilizzati
            </h2>
            
            <h3 className="font-display text-xl font-semibold text-foreground mt-6 mb-3">
              2.1 Cookie Tecnici (Necessari)
            </h3>
            <p>
              Questi cookie sono essenziali per il corretto funzionamento del sito web e non possono essere disattivati. Vengono impostati in risposta ad azioni da te effettuate che costituiscono una richiesta di servizi, come l'impostazione delle preferenze sulla privacy, l'accesso o la compilazione di moduli.
            </p>
            <table className="w-full border-collapse border border-border my-4">
              <thead>
                <tr className="bg-muted">
                  <th className="border border-border p-3 text-left">Cookie</th>
                  <th className="border border-border p-3 text-left">Durata</th>
                  <th className="border border-border p-3 text-left">Finalità</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border border-border p-3">session_id</td>
                  <td className="border border-border p-3">Sessione</td>
                  <td className="border border-border p-3">Gestione della sessione utente</td>
                </tr>
                <tr>
                  <td className="border border-border p-3">cookie_consent</td>
                  <td className="border border-border p-3">12 mesi</td>
                  <td className="border border-border p-3">Memorizza le preferenze sui cookie</td>
                </tr>
              </tbody>
            </table>

            <h3 className="font-display text-xl font-semibold text-foreground mt-6 mb-3">
              2.2 Cookie Analitici
            </h3>
            <p>
              Questi cookie ci permettono di contare le visite e le fonti di traffico in modo da poter misurare e migliorare le prestazioni del nostro sito. Ci aiutano a sapere quali sono le pagine più e meno popolari e vedere come i visitatori si muovono nel sito.
            </p>
            <table className="w-full border-collapse border border-border my-4">
              <thead>
                <tr className="bg-muted">
                  <th className="border border-border p-3 text-left">Cookie</th>
                  <th className="border border-border p-3 text-left">Fornitore</th>
                  <th className="border border-border p-3 text-left">Durata</th>
                  <th className="border border-border p-3 text-left">Finalità</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border border-border p-3">_ga</td>
                  <td className="border border-border p-3">Google Analytics</td>
                  <td className="border border-border p-3">2 anni</td>
                  <td className="border border-border p-3">Distingue gli utenti</td>
                </tr>
                <tr>
                  <td className="border border-border p-3">_ga_*</td>
                  <td className="border border-border p-3">Google Analytics</td>
                  <td className="border border-border p-3">2 anni</td>
                  <td className="border border-border p-3">Mantiene lo stato della sessione</td>
                </tr>
                <tr>
                  <td className="border border-border p-3">_gid</td>
                  <td className="border border-border p-3">Google Analytics</td>
                  <td className="border border-border p-3">24 ore</td>
                  <td className="border border-border p-3">Distingue gli utenti</td>
                </tr>
              </tbody>
            </table>

            <h3 className="font-display text-xl font-semibold text-foreground mt-6 mb-3">
              2.3 Cookie di Marketing (Opzionali)
            </h3>
            <p>
              Questi cookie possono essere impostati attraverso il nostro sito dai nostri partner pubblicitari. Possono essere utilizzati da queste aziende per costruire un profilo dei tuoi interessi e mostrarti annunci pertinenti su altri siti.
            </p>
            <p>
              <strong>Nota:</strong> Attualmente il nostro sito non utilizza cookie di marketing o profilazione.
            </p>

            <h2 className="font-display text-2xl font-bold text-foreground mt-10 mb-4">
              3. Cookie di Terze Parti
            </h2>
            <p>Il nostro sito potrebbe utilizzare servizi di terze parti che potrebbero impostare i propri cookie:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                <strong>Google Analytics:</strong> per l'analisi del traffico web. 
                <a href="https://policies.google.com/privacy" className="text-gold underline underline-offset-2 ml-1" target="_blank" rel="noopener noreferrer">
                  Privacy Policy di Google
                </a>
              </li>
              <li>
                <strong>Google Maps:</strong> per la visualizzazione delle mappe. 
                <a href="https://policies.google.com/privacy" className="text-gold underline underline-offset-2 ml-1" target="_blank" rel="noopener noreferrer">
                  Privacy Policy di Google
                </a>
              </li>
              <li>
                <strong>YouTube:</strong> per l'incorporamento di video. 
                <a href="https://policies.google.com/privacy" className="text-gold underline underline-offset-2 ml-1" target="_blank" rel="noopener noreferrer">
                  Privacy Policy di Google
                </a>
              </li>
              <li>
                <strong>Facebook/Meta:</strong> per i widget social. 
                <a href="https://www.facebook.com/privacy/policy/" className="text-gold underline underline-offset-2 ml-1" target="_blank" rel="noopener noreferrer">
                  Privacy Policy di Meta
                </a>
              </li>
            </ul>

            <h2 className="font-display text-2xl font-bold text-foreground mt-10 mb-4">
              4. Come Gestire i Cookie
            </h2>
            <p>
              Puoi gestire le tue preferenze sui cookie in diversi modi:
            </p>
            
            <h3 className="font-display text-xl font-semibold text-foreground mt-6 mb-3">
              4.1 Tramite il Banner Cookie
            </h3>
            <p>
              Alla prima visita del sito, ti verrà mostrato un banner che ti permette di accettare o rifiutare i cookie non essenziali.
            </p>

            <h3 className="font-display text-xl font-semibold text-foreground mt-6 mb-3">
              4.2 Tramite le Impostazioni del Browser
            </h3>
            <p>Puoi configurare il tuo browser per bloccare o eliminare i cookie. Ecco i link alle guide dei principali browser:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                <a href="https://support.google.com/chrome/answer/95647" className="text-gold underline underline-offset-2" target="_blank" rel="noopener noreferrer">
                  Google Chrome
                </a>
              </li>
              <li>
                <a href="https://support.mozilla.org/it/kb/protezione-antitracciamento-avanzata-firefox-desktop" className="text-gold underline underline-offset-2" target="_blank" rel="noopener noreferrer">
                  Mozilla Firefox
                </a>
              </li>
              <li>
                <a href="https://support.apple.com/it-it/guide/safari/sfri11471/mac" className="text-gold underline underline-offset-2" target="_blank" rel="noopener noreferrer">
                  Safari
                </a>
              </li>
              <li>
                <a href="https://support.microsoft.com/it-it/microsoft-edge/eliminare-i-cookie-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" className="text-gold underline underline-offset-2" target="_blank" rel="noopener noreferrer">
                  Microsoft Edge
                </a>
              </li>
            </ul>

            <h2 className="font-display text-2xl font-bold text-foreground mt-10 mb-4">
              5. Conseguenze della Disattivazione dei Cookie
            </h2>
            <p>
              La disattivazione dei cookie tecnici potrebbe compromettere alcune funzionalità del sito. La disattivazione dei cookie analitici non influenzerà la navigazione ma ci impedirà di migliorare i nostri servizi sulla base delle statistiche di utilizzo.
            </p>

            <h2 className="font-display text-2xl font-bold text-foreground mt-10 mb-4">
              6. Aggiornamenti della Cookie Policy
            </h2>
            <p>
              La presente Cookie Policy può essere aggiornata periodicamente. Ti invitiamo a consultare questa pagina regolarmente per essere informato su eventuali modifiche. La data dell'ultimo aggiornamento è indicata all'inizio del documento.
            </p>

            <h2 className="font-display text-2xl font-bold text-foreground mt-10 mb-4">
              7. Contatti
            </h2>
            <p>
              Per qualsiasi domanda relativa alla presente Cookie Policy o al trattamento dei tuoi dati personali, puoi contattarci all'indirizzo email: taekwondomatteiroma@gmail.com
            </p>

            <h2 className="font-display text-2xl font-bold text-foreground mt-10 mb-4">
              8. Riferimenti Normativi
            </h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Regolamento UE 2016/679 (GDPR)</li>
              <li>D.Lgs. 196/2003 (Codice Privacy) come modificato dal D.Lgs. 101/2018</li>
              <li>Direttiva 2002/58/CE (Direttiva ePrivacy)</li>
              <li>Linee Guida del Garante Privacy sui Cookie del 10 giugno 2021</li>
            </ul>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default CookiePolicy;
